import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=132e2f60&scoped=true&"
import script from "./Warranty.vue?vue&type=script&lang=js&"
export * from "./Warranty.vue?vue&type=script&lang=js&"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=132e2f60&lang=scss&scoped=true&"
import style1 from "./Warranty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e2f60",
  null
  
)

export default component.exports